import React from "react";

const Avatar = ({
  name,
  src,
  size = "md",
  variant = "circle",
  className = "",
}) => {
  const sizes = {
    sm: "w-8 h-8 text-xs",
    md: "w-10 h-10 text-sm",
    lg: "w-12 h-12 text-base",
    xl: "w-16 h-16 text-lg",
  };

  const variants = {
    circle: "rounded-full",
    square: "rounded-lg",
  };

  const getInitials = (name) => {
    if (!name) return "?";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className={`${sizes[size]} ${variants[variant]} object-cover ${className}`}
      />
    );
  }

  return (
    <div
      className={`${sizes[size]} ${variants[variant]} bg-custom-blue text-white flex items-center justify-center font-semibold ${className}`}
    >
      {getInitials(name)}
    </div>
  );
};

export default Avatar;
